<app-page-header icon="assignment" title="Trámites" subtitle="Configuración de trámites del sistema"></app-page-header>

<div class="features-area pb-40 animate__animated animate__fadeIn">
    <div class="container">
        <!-- 🧩 Grilla compacta y fluida -->
        <div class="grid">
            <div class="feature-card">
                <div class="icon">
                    <i class="fas fa-list-ul" aria-hidden="true"></i>
                </div>
                <h3>Listado de Trámites</h3>
                <p>Acceda al listado de trámites del sistema</p>
                <a routerLink="/tramites-listado" class="btn btn-primary"
                    >Ver Trámites</a
                >
            </div>

            <div class="feature-card">
                <div class="icon">
                    <i class="far fa-plus-square" aria-hidden="true"></i>
                </div>
                <h3>Nuevo Trámite</h3>
                <p>Cree una nuevo trámite en el sistema</p>
                <a routerLink="/tramite-alta" class="btn btn-success"
                    >Crear Trámites</a
                >
            </div>

            <div class="feature-card">
                <div class="icon">
                    <i class="fas fa-paperclip" aria-hidden="true"></i>
                </div>
                <h3><b>Adjuntos</b></h3>
                <p>Acceda a la configuración de adjuntos</p>
                <a routerLink="/adjuntos-configuracion" class="btn btn-warning"
                    >Ir a Adjuntos</a
                >
            </div>
        </div>
    </div>
</div>
